export type BalanceByAccounts = Record<string, Record<string, number>>;
export type BalanceByAccountsSymbols = Record<string, Record<string, number>>;
export type BalancesByTime = Record<string, number>;
export type BalancesByTimeSet = {
  ins: BalancesByTime;
  outs: BalancesByTime;
  totalBalanceAmounts: BalancesByTime;
};

export type PlotType = "opening" | "closing" | "balance";

export type BalancePoint = {
  plotDate: number;
  balance: number;
  balanceDate: number;
  ins: number;
  outs: number;
  plotType: PlotType;
};

export type BalanceDate = {
  plotDate: number;
  balanceDate: number;
  plotType: PlotType;
};

export type GranularityProperty = "day" | "week" | "month" | "quarter" | "year";
export const dayGranularity = "day" as GranularityProperty;
export const weekGranularity = "week" as GranularityProperty;
export const monthGranularity = "month" as GranularityProperty;
export const quarterGranularity = "quarter" as GranularityProperty;
export const yearGranularity = "year" as GranularityProperty;

export type GranularityDefault = {
  limit: number;
  limitType: GranularityProperty;
  default: GranularityProperty;
};

export const GranularityDefaults: Array<GranularityDefault> = [
  { limit: 24, limitType: dayGranularity, default: dayGranularity },
  { limit: 168, limitType: dayGranularity, default: weekGranularity },
  { limit: 2, limitType: yearGranularity, default: monthGranularity },
  { limit: 6, limitType: yearGranularity, default: quarterGranularity },
  { limit: null, limitType: null, default: yearGranularity },
];

export type GranularityOption = {
  limit: number;
  limitType: GranularityProperty;
  options: Array<GranularityProperty>;
};

export const GranularityOptions: Array<GranularityOption> = [
  { limit: 21, limitType: dayGranularity, options: [dayGranularity] },
  { limit: 24, limitType: dayGranularity, options: [dayGranularity, weekGranularity] },
  { limit: 3, limitType: monthGranularity, options: [weekGranularity] },
  {
    limit: 168,
    limitType: dayGranularity,
    options: [weekGranularity, monthGranularity, quarterGranularity],
  },
  { limit: 2, limitType: yearGranularity, options: [monthGranularity, quarterGranularity] },
  { limit: 6, limitType: yearGranularity, options: [quarterGranularity, yearGranularity] },
  { limit: null, limitType: null, options: [yearGranularity] },
];

// TODO: Get Sinan to fix this to be a proper type instead of any!
// Moved from GranularityAndGroupingTypes after it was deprecated
export type DetailedBalance = any;
